import React from "react"

const Loading = () => (
  <div className="Loading justify-content-center d-flex flex-column h-100 align-items-center my-5 py-5">
    <h1 className="lead fs-3 mt-4 mb-4 text-dark">Loading...</h1>
    <div className="fs-1 spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
)

export default Loading
